export type TherapistBookingUnavailableReason = "no_services";

export type TherapistBookingAvailability = {
  canBook: boolean;
  reason: TherapistBookingUnavailableReason | null;
};

/**
 * `acceptingNewClients` is deliberately NOT part of this decision: the flag is
 * informational only (it renders as a badge on the profile and the list) and
 * never closes the calendar. Only a therapist without active services is
 * unbookable.
 */
export function getTherapistBookingAvailability(opts: {
  services: readonly unknown[];
}): TherapistBookingAvailability {
  if (opts.services.length === 0) {
    return { canBook: false, reason: "no_services" };
  }

  return { canBook: true, reason: null };
}
